package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class CvConfig(
    val primaryColor: String? = null,          // Couleur principale (ex: titres, bordures)
    val secondaryColor: String? = null,        // Couleur secondaire (accents, sous-titres)
    val backgroundColor: String? = null,       // Fond du document
    val backgroundSidebarColor: String? = null,
    val textColor: String? = null,             // Couleur principale du texte
    val subtitleColor: String? = null,         // Couleur des sous-titres
    val accentColor: String? = null,           // Accent visuel (barres, séparateurs)
    val fontFamily: String = "Helvetica",          // Police d’écriture principale
    val fontSizeTitle: Float? = 14f,                // Taille des titres
    val fontSizeSubtitle: Float? = 11f,             // Taille des sous-titres
    val fontSizeText: Float? = 9.5f,                // Taille du texte
)